import React, { Component } from "react"
import { printMany } from "../util/certidaodivida"
import { TextField } from "@material-ui/core"
import {
  hideWaiting,
  showWaiting,
  mapErrors,
  showNotification
} from "../util/Constants"
import Grid from "@material-ui/core/Grid"
import Button from "../components/CustomButtons/Button"
import DialogContent from "@material-ui/core/DialogContent"
import DialogTitle from "@material-ui/core/DialogTitle"
import DialogActions from "@material-ui/core/DialogActions"
import Dialog from "@material-ui/core/Dialog"
export default class PrintCertidoesModal extends Component {
  constructor() {
    super()
    this.handleChange = this.handleChange.bind(this)
    this.printManyCertidoes = this.printManyCertidoes.bind(this)
    this.state = {
      errors: {}
    }
  }
  handleChange(e) {
    let value = e.target.value
    let name = e.target.name
    let errors = { ...this.state.errors }
    delete errors[name]
    this.setState({
      [name]: value,
      errors: errors
    })
  }
  printManyCertidoes(e) {
    e.preventDefault()
    var ano = this.state.ano
    var numeroInicial = this.state.numero_inicial
    var numeroFinal = this.state.numero_final
    let response = (error, data) => {
      if (error) {
        hideWaiting()
        const reader = new FileReader()
        reader.addEventListener("loadend", e => {
          const text = e.srcElement.result
          try {
            let error = JSON.parse(text)
            this.setState({
              errors: mapErrors({ response: { data: error } })
            })
          } catch (error) {
            showNotification(
              "top",
              "center",
              "Ocorreram erros, verifique sua conexão e tente novamente",
              "danger"
            )
          }
        })
        reader.readAsText(error.response.data)
      } else {
        hideWaiting()
        var url = URL.createObjectURL(data)
        let tempLink = document.createElement("a")
        tempLink.setAttribute("target", "_blank")
        tempLink.setAttribute("href", `${url}`)
        tempLink.setAttribute("style", "display:none;")
        document.body.appendChild(tempLink)
        tempLink.click()
        document.body.removeChild(tempLink)
        this.props.toggleModal()
      }
    }
    showWaiting()
    printMany(ano, numeroInicial,numeroFinal, response)
  }
  render() {
    return (
      <Dialog
        style={{ zIndex: "4" }}
        open={this.props.showModal || false}
        onClose={this.props.toggleModal}
        fullWidth
        maxWidth="lg"
        aria-labelledby="form-dialog-title"
      >
        <form onSubmit={e => this.printManyCertidoes(e)}>
          <DialogTitle id="form-dialog-title">
            Digite o ano e o numero da certidão. PS:Deixar o numero vazio para
            imprimir todas do ano selecionado
          </DialogTitle>
          <DialogContent>
            <Grid container>
              <TextField
                id="outlined-select-currency"
                name="ano"
                label="Ano das certidões"
                required
                fullWidth
                error={this.state.errors.ano}
                helperText={this.state.errors.ano}
                rowsMax="3"
                type="numeric"
                value={this.state.ano || ""}
                onChange={this.handleChange}
                margin="normal"
                variant="outlined"
              />
              <TextField
                id="outlined-select-currency"
                name="numero_inicial"
                label="Numero inicial"
                fullWidth
                required
                error={this.state.errors.numero_inicial}
                helperText={this.state.errors.numero_inicial}
                rowsMax="3"
                type="numeric"
                value={this.state.numero_inicial || ""}
                onChange={this.handleChange}
                margin="normal"
                variant="outlined"
              />
              <TextField
                id="outlined-select-currency"
                name="numero_final"
                label="Numero final"
                fullWidth
                required
                error={this.state.errors.numero_final}
                helperText={this.state.errors.numero_final}
                rowsMax="3"
                type="numeric"
                value={this.state.numero_final || ""}
                onChange={this.handleChange}
                margin="normal"
                variant="outlined"
              />
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.props.toggleModal} color="danger">
              Cancelar
            </Button>
            <Button type="submit" color="success">
              Gerar
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    )
  }
}
